import React, { useState, useEffect, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import {
  SvgAlertPeopleCoat,
  SvgAlertPeopleTrousers,
  SvgAlertVehicleColor,
  SvgLogo,
  SvgToastInfo,
} from "ui/svgs";
import clsx from "clsx";
import {
  formatAlertStatusSDKToDisplay,
  getAlertStatusStyles,
  getEventText,
} from "lib/utils";
import dayjs from "dayjs";
import { Popover, Progress, Tooltip } from "antd";
import { ALERT_VEHICLE_CAR_COLOR } from "lib/constants";
import { useService } from "pages/dashboard/alerts/service";
import { REGION_INDEX_COLOR } from "lib/constants";
const conicColors = {
  "0%": "#ff0000",
  "50%": "#ffe58f",
  "100%": "#87d068",
};
function calculateProgress(relevance) {
  //relevant score is between -2 to 3 and we need to convert it to 0 to 100
  relevance = (relevance + 2) * 20;
  relevance = Math.min(100, Math.max(0, relevance));
  return relevance;
}
export default function AlertCard({ alert, onSelectAlert, active }) {
  const imgRef = useRef<HTMLImageElement>(null);
  const { getSnapShotByAlertObj, getTargetImgByAlertObj } = useService();
  const [naturalSize, setNaturalSize] = useState({ width: 0, height: 0 });
  const [snapShotSrc, setSnapShotSrc] = useState(null);
  const [targetImgSrc, setTargetImgSrc] = useState("");
  const [snapShotWithBoxSrc, setSnapShotWithBoxSrc] = useState("");
  const [showPopover, setShowPopover] = useState(false);
  const itemRef = useRef(null);
  useEffect(() => {
    if (!alert) {
      return;
    }
    getSnapShotByAlertObj(alert)
      .then((data) => {
        itemRef.current && setSnapShotSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));

    // getTargetImgByAlertObj(alert)
    //   .then((data) => {
    //     itemRef.current &&
    //       data &&
    //       setTargetImgSrc([URL.createObjectURL(data)]);
    //   })
    //   .catch((e) => console.error(e));
  }, [alert.mediaId]);

  useEffect(() => {
    if (
      !showPopover ||
      !alert ||
      Array.isArray(alert.searchResult?.boundingBoxList)
    ) {
      return;
    }

    getTargetImgByAlertObj(alert)
      .then((data) => {
        data && itemRef.current && setTargetImgSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));
  }, [showPopover, alert]);

  useEffect(() => {
    if (
      !showPopover ||
      !alert ||
      !Array.isArray(alert.searchResult?.boundingBoxList) ||
      !naturalSize
    ) {
      return;
    }

    createImageWithBox(alert.searchResult?.boundingBoxList);
  }, [showPopover, naturalSize]);

  useEffect(() => {
    return () => {
      snapShotSrc && URL.revokeObjectURL(snapShotSrc);
    };
  }, [snapShotSrc]);

  useEffect(() => {
    return () => {
      targetImgSrc && URL.revokeObjectURL(targetImgSrc);
    };
  }, [targetImgSrc]);

  const handleSnapshotLoad = async () => {
    if (imgRef.current) {
      const { naturalWidth, naturalHeight } = imgRef.current;
      setNaturalSize({ width: naturalWidth, height: naturalHeight });
      console.log("handleSnapshotLoad:", naturalWidth, naturalHeight);
    }
  };

  const createImageWithBox = async (cropAreas) => {
    const img = imgRef.current;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = naturalSize.width;
    canvas.height = naturalSize.height;

    try {
      // 绘制原始图片
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      cropAreas.forEach((area, i) => {
        // const { x, y, width, height } = area.rawBox;

        let { x1, y1, x2, y2 } = area.rawBox;
        const scalingRatio = naturalSize.width / area.rawBox.width;
        x1 = x1 * scalingRatio;
        y1 = y1 * scalingRatio;
        x2 = x2 * scalingRatio;
        y2 = y2 * scalingRatio;
        const safeCropArea = {
          x: Math.max(0, Math.min(x1, naturalSize.width)),
          y: Math.max(0, Math.min(y1, naturalSize.height)),
          width: Math.max(0, Math.min(x2 - x1, naturalSize.width - x1 - 2)),
          height: Math.max(0, Math.min(y2 - y1, naturalSize.height - y1 - 2)),
        };
        const color =
          REGION_INDEX_COLOR[i % Object.values(REGION_INDEX_COLOR).length];

        ctx.strokeStyle = color;
        ctx.lineWidth = 10;
        ctx.strokeRect(
          safeCropArea.x,
          safeCropArea.y,
          safeCropArea.width,
          safeCropArea.height,
        );
      });
    } catch (e) {
      console.warn("draw box error", e);
    }
    // 将 canvas 转换为图片 URL
    const dataUrl = canvas.toDataURL("image/png");
    setSnapShotWithBoxSrc(dataUrl);
  };

  const popContent = () => {
    if (alert.searchResult && snapShotWithBoxSrc) {
      return (
        <div
          className="flex max-w-[800px] w-[800px] max-h-[600px] h-[600px] overflow-hidden gap-1 items-center "
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <TransformWrapper
            initialScale={1}
            initialPositionX={0}
            initialPositionY={0}
            centerOnInit={true}
            disablePadding={true}
            doubleClick={{ disabled: true }}
          >
            {() => (
              <React.Fragment>
                <TransformComponent
                  wrapperClass="!w-full !h-full"
                  contentClass="!w-full !h-full flex justify-center items-center"
                >
                  <img
                    src={snapShotWithBoxSrc}
                    className="p-0.5 bg-white max-w-full max-h-full !rounded-lg object-contain"
                  />
                </TransformComponent>
              </React.Fragment>
            )}
          </TransformWrapper>
        </div>
      );
    } else if (targetImgSrc) {
      return (
        <div className="flex max-w-[300px] w-[300px] max-h-[300px] h-[300px] overflow-hidden gap-1 items-center">
          <img
            src={targetImgSrc}
            className="p-0.5 bg-white max-w-full max-h-full !rounded-lg object-contain"
          />
        </div>
      );
    } else {
      return (
        <div className="flex items-center justify-center w-64 h-48 border rounded-lg bg-white">
          <div
            className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          ></div>
        </div>
      );
    }
  };

  const displaySvgIcons = () => {
    const attrs = alert.attrs || {};
    let matchedCarColor = alert.matchedVehicle?.color;
    if (matchedCarColor === "unknown") matchedCarColor = "";
    return (
      <div className="flex mx-2">
        {matchedCarColor && (
          <SvgAlertVehicleColor
            width="16"
            fill={ALERT_VEHICLE_CAR_COLOR[matchedCarColor]}
          />
        )}
        {!matchedCarColor &&
          attrs.vehicles?.length > 0 &&
          attrs.vehicles[0].color !== "color_unknown" && (
            <SvgAlertVehicleColor
              width="16"
              fill={ALERT_VEHICLE_CAR_COLOR[attrs.vehicles[0].color]}
            />
          )}
        {attrs.persons?.length > 0 &&
          attrs.persons[0].coatColor &&
          attrs.persons[0].coatColor !== "color_unknown" && (
            <SvgAlertPeopleCoat
              width="16"
              fill={ALERT_VEHICLE_CAR_COLOR[attrs.persons[0].coatColor]}
            />
          )}
        {attrs.persons?.length > 0 &&
          attrs.persons[0].trousersColor &&
          attrs.persons[0].trousersColor !== "color_unknown" && (
            <SvgAlertPeopleTrousers
              width="16"
              fill={ALERT_VEHICLE_CAR_COLOR[attrs.persons[0].trousersColor]}
            />
          )}
      </div>
    );
  };
  return (
    <>
      <div
        id={"alert_" + alert.id}
        ref={itemRef}
        className={clsx(
          "focus:outline-none py-2.5 px-6 cursor-pointer w-full flex items-center gap-3 ",
          active ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-zinc-100 ",
        )}
        onClick={() => onSelectAlert(alert)}
        style={{
          scrollSnapAlign: "end",
        }}
      >
        <Popover
          arrow={false}
          placement="right"
          overlayInnerStyle={{
            padding: 0,
            borderRadius: "16px",
            backgroundColor: "transparent",
            boxShadow: "none",
          }}
          //trigger={["click"]}
          onOpenChange={setShowPopover}
          content={popContent()}
        >
          <div className="relative rounded-lg h-[70px] flex-shrink-0 aspect-video flex items-center justify-center bg-zinc-100">
            {snapShotSrc ? (
              <img
                ref={imgRef}
                src={snapShotSrc}
                alt="Camera Snapshot"
                className="aspect-video rounded-lg"
                width="124"
                height="90"
                onLoad={handleSnapshotLoad}
              />
            ) : (
              <SvgLogo width="28" className="fill-zinc-400" />
            )}
          </div>
        </Popover>
        <div className="flex flex-col justify-between flex-grow gap-1 max-w-[200px]">
          <div className="flex justify-between w-full">
            <div className="flex space-x-1">
              <p className="text-sm font-medium leading-tight">
                {alert.matchedVehicle
                  ? alert.matchedVehicle.licensePlate || "-"
                  : getEventText(
                    alert?.eventTypes?.at(0),
                    alert?.attrs?.vehicles?.at(0)?.plate?.no,
                  )}
              </p>
              {displaySvgIcons()}
              {alert?.assetTracking && (
                <Tooltip
                  title={
                    <div>
                      <p className="text-center">
                        Database: {alert?.assetTracking?.name || "-"}
                      </p>
                      <p className="text-center">
                        Record: {alert?.assetTracking?.recordName}
                        {"(" +
                          (alert?.assetTracking?.threshold?.toFixed(2) || "-") +
                          ")"}
                      </p>
                      <p className="text-center">
                        <a
                          className="font-semibold text-center hover:text-zinc-100"
                          href={`/dashboard/database/${alert?.assetTracking?.id}?tag=${alert?.assetTracking?.recordName}`}
                          target="_blank"
                        >
                          View Details{">"}
                        </a>
                      </p>
                    </div>
                  }
                >
                  <div className="fill-neutral-500 hover:fill-neutral-400">
                    <SvgToastInfo width="16" className="" />
                  </div>
                </Tooltip>
              )}
            </div>
            <div className="flex items-center gap-1">
              <p
                className="text-sm overflow-hidden break-words text-nowrap text-ellipsis px-2 rounded-md font-semibold"
                style={getAlertStatusStyles(alert?.status)}
              >
                {formatAlertStatusSDKToDisplay(alert?.status ?? "")}
              </p>
            </div>
          </div>
          <div className="flex justify-between w-full text-neutral-500 text-sm">
            <Tooltip title={alert.site?.name}>
              <p className="max-w-32 overflow-hidden break-words text-nowrap text-ellipsis break-all">
                {alert.site.name}
              </p>
            </Tooltip>
            <p>{dayjs(parseInt(alert.createdAt)).format("MMM DD h:mm A")}</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p className="max-w-full text-neutral-500 overflow-hidden break-all break-words text-nowrap text-ellipsis">
              {alert.camera.name}
            </p>
            {!alert.matchedVehicle && (
              <div style={{ display: "flex" }}>
                <Popover
                  content={Number(
                    alert.searchResult?.searchRerankScore ||
                    alert.searchResult?.searchScore,
                  ).toFixed(2)}
                  placement="right"
                >
                  <Progress
                    size={{ width: 80, height: 5 }}
                    showInfo={false}
                    percent={
                      alert.searchResult?.searchRerankScore
                        ? calculateProgress(
                          Number(alert.searchResult?.searchRerankScore) || -2,
                        )
                        : Math.min(
                          100,
                          Math.max(0, alert.searchResult.searchScore * 100),
                        )
                    }
                    strokeColor={conicColors}
                  />
                </Popover>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
